import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { applyDocumentMeta } from "./utils/documentMeta";
applyDocumentMeta();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-406" data-mp="21ck43oum46jw" />);
}